const {server_ip}= require('../config');

export async function insertNewTeacher(token,schoolId,username,password,name,mobile='',isPrimary=false){
    try {
        const response= await fetch(`${server_ip}/api2/users/admin/addTeacher`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                username,password,name,schoolId,mobile,isPrimary
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function teacherInsertNewTeacher(token,username,password,name,mobile='',isPrimary=false){
    try {
        const response= await fetch(`${server_ip}/api2/users/teacher/addTeacher`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                username,password,name,mobile,isPrimary
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function insertNewStudent(token,schoolId,students,isPrimary=false){
    try {
        const response= await fetch(`${server_ip}/api2/users/admin/addStudents`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                students,schoolId,isPrimary
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function teacherInsertNewStudent(token,students,isPrimary=false){
    try {
        const response= await fetch(`${server_ip}/api2/users/teacher/addStudents`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                students,isPrimary
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function fetchUserList(token,filter,options){
    try {
        const response= await fetch(`${server_ip}/api2/users/admin/list`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                filter,options
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function teacherFetchUserList(token,filter,options){
    try {
        const response= await fetch(`${server_ip}/api2/users/teacher/list`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                filter,options
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function updateUser(token,userId,data){
    try {
        const response= await fetch(`${server_ip}/api2/users/admin/updateUser/${userId}`,{
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(
                data
            ),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function teacherUpdateUser(token,userId,data){
    try {
        const response= await fetch(`${server_ip}/api2/users/teacher/updateUser/${userId}`,{
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(
                data
            ),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function deleteUser(token,userId){
    try {
        const response= await fetch(`${server_ip}/api2/users/admin/deleteUser`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                userId
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}

export async function teacherDeleteUser(token,userId){
    try {
        const response= await fetch(`${server_ip}/api2/users/teacher/deleteUser`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                userId
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}

export async function fetchUserDataById(token){
    try {
        const response= await fetch(`${server_ip}/api2/users/data`,{
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}

export async function primaryStudentPublicRegister(schoolId,studentName,studentEmail,class_,gender,password){
    try {
        const response= await fetch(`${server_ip}/api2/users/public/pstudent/register`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                schoolId,
                studentName,
                studentEmail,
                class: class_,
                gender,
                password
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}